{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXVideoPlayer.Consts;

interface

uses
  WEBLib.TMSFNCWXMediaPlayer.Consts;

const
  TOGGLEPIP = CONTROL_ID + 'TogglePiP(%s)';
  TOGGLEENABLEPIP = CONTROL_ID + 'ToggleEnablePiP(%s)';
  TOGGLEAUTOPIP = CONTROL_ID + 'ToggleAutoPiP(%s)';
  VIDEOPOSTER = CONTROL_ID + 'SetPoster("%S")';

  ONVIDEOPIPENTER = 'ONPIPENTER';
  ONVIDEOPIPLEAVE = 'ONPIPLEAVE';

  function GetWXVideoScript(AControlID: string): string;
  function GetWXInitializeVideoScript(AControlID, ADefaultEventDataObject:string): string;

implementation

function GetWXVideoScript(AControlID: string):string;
begin
  Result := LB +
    '  function ' + AControlID + 'TogglePiP(a){' + LB +
    '    if(document.pictureInPictureEnabled || document.getElementById("' + AControlID + '").disablePictureInPicture){ ' + LB +
    '      if(a) { ' + LB +
    '        document.getElementById("' + AControlID + '").requestPictureInPicture();' + LB +
    '      } else { ' + LB +
    '        document.exitPictureInPicture();' + LB +
    '      }' + LB +
    '    }' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'ToggleEnablePiP(a){' + LB +
    '    document.getElementById("' + AControlID + '").disablePictureInPicture = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'ToggleAutoPiP(a){' + LB +
    '    document.getElementById("' + AControlID + '").autoPictureInPicture = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'SetPoster(a){' + LB +
    '    if (a == null || a.trim() === ""){' + LB +
    '      document.getElementById("' + AControlID + '").removeAttribute("poster");' + LB +
    '    } else { ' + LB +
    '      document.getElementById("' + AControlID + '").poster = a;' + LB +
    '    }' + LB +
    '  }';
end;

function GetWXInitializeVideoScript(AControlID, ADefaultEventDataObject:string):string;
begin
  Result := LB +
    '    e.onenterpictureinpicture = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONVIDEOPIPENTER + '";' + LB +
    '      var customdata = true;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }' + LB +
    '    e.onleavepictureinpicture = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONVIDEOPIPLEAVE + '";' + LB +
    '      var customdata = false;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }';
end;

end.
